package com.macrofocus.eflux.ui

import emotion.react.css
import mui.material.SvgIcon
import mui.system.sx
import react.FC
import react.PropsWithChildren
import react.dom.svg.ReactSVG.g
import react.dom.svg.ReactSVG.path
import web.cssom.MarginLeft
import web.cssom.px
import web.dom.ElementId

external interface MacrofocusLogoProps : PropsWithChildren,mui.system.PropsWithSx {
    var marginLeft: MarginLeft?
}

val styledMacrofocusIcon = FC<MacrofocusLogoProps>
//withStyles("macrofocus-icon", {
//    "icon" {
//        put("width", "283.463px")
//        put("height", "54.333px")
//        put("padding", "4px")
////        put("margin-top", "10px")
//    }
//    "rootGroup" {
////        put("fill", "none")
////        put("fill-rule", "evenodd")
////        put("stroke", "none")
////        put("stroke-width", "1")
//    }
//    "black" {
////        fill(Color("#000000"))
//        fill(Color("#808080"))
////        fill(Color("#00B5E4"))
//
//    }
//    "white" {
////        stroke(Color("#000000"))
////        fill(Color("#FFFFFF"))
//        fill(Color.transparent)
//        stroke(Color("#808080"))
////        stroke(Color("#00B5E4"))
//        strokeWidth("1.1339")
//    }
//})
{ props: MacrofocusLogoProps ->
//    val icon by props.styleSets
//    val rootGroup by props.styleSets
//    val black by props.styleSets
//    val white by props.styleSets
    SvgIcon {
//        className = icon
        sx {
            width = 210.7315.px // 283.463.px (this affects the horizontal position
            height = 34.1665.px // 54.333.px (this affects the size)
            padding = 2.px
            if(props.marginLeft != null) {
                marginLeft = props.marginLeft
            }
        }
        viewBox = "0 0 283.463 54.333"

        g {
//            className = rootGroup
            css {
            }
            id = ElementId("Macrofocus logo")

            path {
//                className = white
                css {
                    this@path.fill = "transparent"
                    this@path.stroke = "#808080"
                    this@path.strokeWidth = 1.1339
                }
                d =
                    "M75.852,22.948h-5.789v-7.766h5.789 c0-10.518,3.67-13.765,13.906-13.765c1.906,0,3.883,0.141,5.789,0.211V10.1c-1.129-0.141-2.188-0.212-3.247-0.212 c-2.753,0-4.447,0.353-4.447,3.671v1.624h7.2v7.766h-7.2v28.871h-12V22.948z"
            }
            path {
//                className = white
                css {
                    this@path.fill = "transparent"
                    this@path.stroke = "#808080"
                    this@path.strokeWidth = 1.1339
                }
                d =
                    "M107.842,33.573c0-4.659,1.694-10.236,7.271-10.236 c5.577,0,7.341,5.577,7.341,10.236s-1.764,10.165-7.341,10.165C109.537,43.738,107.842,38.232,107.842,33.573z M95.842,33.573 c0,11.012,7.906,19.342,19.271,19.342s19.342-8.33,19.342-19.342s-7.977-19.412-19.342-19.412S95.842,22.561,95.842,33.573z"
            }
            path {
//                className = white
                css {
                    this@path.fill = "transparent"
                    this@path.stroke = "#808080"
                    this@path.strokeWidth = 1.1339
                }
                d =
                    "M162.959,28.594c-0.07-3.105-2.823-5.294-5.859-5.294 c-6.705,0-7.764,5.718-7.764,10.8c0,4.73,2.047,9.601,7.129,9.601c4.166,0,6.282-2.399,6.848-6.282h11.647 c-1.06,9.812-8.683,15.459-18.425,15.459c-11.012,0-19.2-7.553-19.2-18.777c0-11.646,7.411-19.977,19.2-19.977 c9.106,0,17.225,4.8,18.071,14.471H162.959z"
            }
            path {
//                className = white
                css {
                    this@path.fill = "transparent"
                    this@path.stroke = "#808080"
                    this@path.strokeWidth = 1.1339
                }
                d =
                    "M215.69,51.819h-11.648v-5.012h-0.141 c-2.258,3.741-6.918,6.07-11.152,6.07c-10.519,0-13.554-6.07-13.554-15.671V15.182h12.001V36.43c0,4.871,2.117,6.564,5.93,6.564 c2.611,0,6.564-1.693,6.564-8.188V15.182h12V51.819z"
            }
            path {
//                className = white
                css {
                    this@path.fill = "transparent"
                    this@path.stroke = "#808080"
                    this@path.strokeWidth = 1.1339
                }
                d =
                    "M231.36,39.749c0,1.834,0.777,3.176,1.977,4.094 c1.13,0.848,2.754,1.271,4.447,1.271c2.33,0,5.647-0.988,5.647-3.882c0-2.824-3.741-3.389-5.858-3.883 c-7.553-1.906-17.013-2.118-17.013-12c0-8.824,9.53-11.225,16.729-11.225c8.048,0,16.447,2.329,16.871,11.859h-11.082 c0-1.553-0.564-2.541-1.553-3.177s-2.33-0.918-3.812-0.918c-1.977,0-5.152,0.212-5.152,2.753c0,3.459,8.047,4.095,13.553,5.295 c7.412,1.482,9.318,6.847,9.318,9.883c0,9.812-9.318,13.059-17.577,13.059c-8.683,0-17.577-2.895-17.931-13.129H231.36z"
            }
            path {
//                className = black
                css {
                    this@path.fill = "#808080"
                }
                d =
                    "M0,22.947h6.656v2.864h0.081c1.25-2.098,3.469-3.469,6.01-3.469c2.622,0,4.961,0.846,6.091,3.388 c1.654-2.219,3.711-3.388,6.535-3.388c6.655,0,7.381,5.041,7.381,9.035v12.504h-6.857V31.579c0-2.258-1.089-3.59-2.864-3.59 c-2.945,0-3.227,2.26-3.227,5.647v10.245h-6.857V31.982c0-2.46-0.726-3.993-2.582-3.993c-2.46,0-3.509,1.412-3.509,5.688v10.205H0 V22.947z"
            }
            path {
//                className = black
                css {
                    this@path.fill = "#808080"
                }
                d =
                    "M43.887,37.872c0-1.654,1.291-2.299,2.824-2.662c1.492-0.403,3.268-0.524,4.235-1.129 c0.161,4.315-0.928,6.171-4.195,6.171C45.218,40.251,43.887,39.566,43.887,37.872z M44.29,29.401 c0.323-1.775,1.533-2.622,3.429-2.622c1.412,0,3.308,0.604,3.308,2.179c0,1.291-0.645,1.693-1.815,1.936 c-4.76,0.969-12.182,0.443-12.182,7.261c0,4.316,3.146,6.333,7.14,6.333c2.501,0,5.123-0.727,6.897-2.582 c0.081,0.686,0.161,1.332,0.403,1.977h6.898c-0.807-1.653-0.807-3.59-0.807-5.364V29.36c0-5.93-4.8-7.018-9.762-7.018 c-2.379,0-4.8,0.402-6.655,1.451c-1.855,1.09-3.146,2.864-3.268,5.607H44.29z"
            }
            path {
//                className = black
                css {
                    this@path.fill = "#808080"
                }
                d =
                    "M76.52,30.611c-0.041-1.774-1.614-3.025-3.349-3.025c-3.832,0-4.437,3.268-4.437,6.172c0,2.702,1.17,5.485,4.074,5.485 c2.38,0,3.59-1.371,3.913-3.59h6.655c-0.605,5.607-4.961,8.834-10.528,8.834c-6.292,0-10.972-4.316-10.972-10.729 c0-6.655,4.235-11.415,10.972-11.415c5.203,0,9.842,2.742,10.326,8.269H76.52z"
            }
            path {
//                className = black
                css {
                    this@path.fill = "#808080"
                }
                d =
                    "M87.854,22.947h6.656v3.671h0.081c1.009-2.662,3.348-4.074,6.293-4.074c0.524,0,1.089,0.04,1.613,0.161v6.253 c-0.887-0.242-1.694-0.404-2.622-0.404c-3.388,0-5.163,2.34-5.163,4.962v10.366h-6.857V22.947z"
            }
            path {
//                className = black
                css {
                    this@path.fill = "#808080"
                }
                d =
                    "M110.974,33.434c0-2.662,0.968-5.849,4.154-5.849c3.187,0,4.195,3.187,4.195,5.849s-1.008,5.809-4.195,5.809 C111.942,39.243,110.974,36.096,110.974,33.434z M104.117,33.434c0,6.293,4.518,11.053,11.012,11.053 c6.495,0,11.053-4.76,11.053-11.053c0-6.292-4.558-11.092-11.053-11.092C108.634,22.342,104.117,27.142,104.117,33.434z"
            }
        }
    }
}
